import PropTypes from "prop-types";
import React from "react";

const TATRenderer = ({ rowData }) => {
  const { hexCode, description, remainingDays, colorCode } = rowData.tat;

  return (
    <div 
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}   
        >
      <div
        style={{
          borderRadius: "30px",
          backgroundColor: `${hexCode}1A`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.2rem 0.5rem",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: `${colorCode}`,
            }}
          />
          <span style={{ color: colorCode }}>{description}</span>
        </div>
      </div>
      <span
        style={{
          fontWeight: "bold",
        }}
      >
        {remainingDays}
      </span>
    </div>
  );
};

TATRenderer.propTypes = {
  rowData: PropTypes.shape({
    tat: PropTypes.shape({
      hexCode: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      remainingDays: PropTypes.number.isRequired,
      colorCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default TATRenderer;
